if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      
                this.formId = "#" + this.form.getAttribute('id');
                this.productVariant = `${this.formId} .product-form__variants`;
                this.optionSelector = `${this.formId} .option-selector`;
                this.optionSelector__radio = `${this.formId} .option-selector-radio`;
                this.formSubmitButton = `${this.formId} [type="submit"]`;
                this.alertWrapper = `${this.formId} .alert-wrapper`;
                
                $(document).on('change', `${this.optionSelector}`, this.onOptionSelectorChange.bind(this));
                $(document).on('change', `${this.optionSelector__radio}`, this.onOptionSelectorRadioChange.bind(this));
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				const submitButton = this.querySelector('[type="submit"]');

				submitButton.setAttribute("disabled", true);
				submitButton.classList.add("loading");
              
              	
              	const data = $(this.form).find('#choose-organic-toppings').length 
                	? this.onCookieShakeAddToCart()
                    : {...JSON.parse(serializeForm(this.form)), sections_url: window.location.pathname }

               	if(!data) return;
                            
  				const body = JSON.stringify(data);
 
				fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
					.then((response) => response.json())
                	.then((data) => {
                  		if((data.items && !data.items.length) || !data) return;
                        if(data.description){
                          alert(data.description)
                          return;
                        }
                  		data.items && data.items.length
                          ? data.items.forEach(item => $(this).trigger("addItemAddToCartBtn", item))
                          : $(this).trigger("addItemAddToCartBtn", data);
					})
					.catch((e) => {
                  		console.error(e);
					})
					.finally(() => {
						submitButton.classList.remove("loading");
						submitButton.removeAttribute("disabled");
					});
			}

            onCookieShakeAddToCart(){
              const selected_toppings = $(this.form).find('#choose-organic-toppings input:checked');
              
              const form = JSON.parse(serializeForm(this.form));
              const products = [];
              selected_toppings.length && $(selected_toppings).each((index, topping) => {
                const variantID = $(topping).attr('variant');
                if(!variantID) return;
                const data = {
                  id: +variantID, 
                  quantity: +form.quantity ? +form.quantity : 1,
                  properties: {
                    _cookie_shake_topping: true,
                  }
                }
                products.push(data);
              });
 
              products.push(form);
              
              const uniqueID = products.reduce((sum,item) => sum += +item.id, 0);
              if(uniqueID !== 0 && uniqueID !== +form.id){
                products.forEach(product => product.properties['_id'] = uniqueID)
              }
              
              const data = {
                items: products
              };
              
              return data;
            }

            onOptionSelectorChange(evt){
              const triggered_input = $(evt.target);
              this.getSelectedProductVariant(triggered_input);
            }

            onOptionSelectorRadioChange(evt){
              const triggered_input = $(evt.target);
              this.getSelectedProductVariant(triggered_input);
            }

            getSelectedProductVariant(triggered_input){
              var find_variant = "";
              var option_public_name = [];
              
              var input_selector = `${this.optionSelector}`;
              if(triggered_input.hasClass('option-selector-radio')){
                var input_selector = `${this.optionSelector__radio}:checked`;
                var tab_trigger = triggered_input.closest('.product-toppings-wrapper').attr('aria-labelledby');
                tab_trigger = $(`#${tab_trigger}`);
                
                if(tab_trigger.hasClass('active')){
                  var new_option_title = triggered_input.closest('.product-toppings-item').find('.product-toppings-item--title').html();
                  tab_trigger.trigger("click");
                  tab_trigger.find('.product-toppings-item--title').html(new_option_title);
                }
                
              }
              
              $(input_selector).each(function(i, el){
                var option_title = $(el).data('option-title');
                var option_value = $(el).val();
                find_variant += `[${option_title}="${option_value}"]`;
                
                if(triggered_input.hasClass('option-selector-radio')){
                  option_public_name[i] = $(el).closest('.product-toppings-item').find('.product-toppings-item--title').text();
                } else {
                  /*when input is tag select*/
                  option_public_name[i] = $(el).find('option:selected').text();
                }
              });
              
              /*if the variant is unavailable - its options will do not have these attributes and cannot be found to select*/
              var selected_variant_value = $(`${this.productVariant} option${find_variant}`).first().val();
              $(this.productVariant).val(selected_variant_value);
              
              
              if(!selected_variant_value || typeof selected_variant_value == "undefined"){
                this.allowFormSubmit(false);
              }
              else {
                this.allowFormSubmit(true);
                
                $(`${this.formId} #property_option_0`).val(option_public_name[0]);
                $(`${this.formId} #property_option_1`).val(option_public_name[1]);
              }
            }

            allowFormSubmit(set_enable = false){
              if(set_enable == true){
                $(this.formSubmitButton).prop('disabled', false);
                $('.product-form-row__buttons').removeClass('hide');
                $('.cookie-shake-bis-trigger').addClass('hide');
              } else {
                $(this.formSubmitButton).prop('disabled', true);
                $('.cookie-shake-bis-trigger').removeClass('hide');
                $('.product-form-row__buttons').addClass('hide');
              }
            }
		}
	);
}
